import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  ListItem,
  ListItemText,
  Grid,
  TextField,
  Button,
  IconButton,
  Typography
} from "@material-ui/core";
import LabeledAutocomplete from "js/components/Shared/Form/Fields/LabeledAutocomplete";
import DeleteIcon from "@material-ui/icons/Delete";

export default React.memo(function ListaInRule({
  suggestions,
  onRemove,
  id,
  estado,
  onUpdate
}) {
  const [entrada, setEntrada] = useState(estado ? estado.entrada : null);
  const [salida, setSalida] = useState(estado ? estado.salida : null);
  const prevEstadoRef = useRef();
  const isUpdatingRef = useRef(false);

  // Memoizar la función de actualización para evitar recreaciones
  const handleUpdate = useCallback(
    (newEntrada, newSalida) => {
      if (isUpdatingRef.current) return; // Evitar loops infinitos

      isUpdatingRef.current = true;
      const newEstado = { ...estado, entrada: newEntrada, salida: newSalida };
      onUpdate(newEstado, id);
      setTimeout(() => {
        isUpdatingRef.current = false;
      }, 0);
    },
    [estado, onUpdate, id]
  );

  // Solo actualizar cuando realmente cambie el estado
  useEffect(
    () => {
      const prevEstado = prevEstadoRef.current;
      if (
        !prevEstado ||
        JSON.stringify(prevEstado) !== JSON.stringify(estado)
      ) {
        prevEstadoRef.current = estado;
        setEntrada(estado ? estado.entrada : null);
        setSalida(estado ? estado.salida : null);
      }
    },
    [estado]
  );

  // Solo llamar onUpdate cuando cambien los valores locales
  useEffect(
    () => {
      const currentEntrada = estado && estado.entrada ? estado.entrada : null;
      const currentSalida = estado && estado.salida ? estado.salida : null;

      if (entrada !== currentEntrada || salida !== currentSalida) {
        handleUpdate(entrada, salida);
      }
    },
    [entrada, salida, handleUpdate, estado]
  );

  const handleEntradaChange = useCallback(e => {
    setEntrada(e.target.value);
  }, []);

  const handleSalidaChange = useCallback(value => {
    setSalida(value);
  }, []);

  const handleRemove = useCallback(
    () => {
      onRemove(id);
    },
    [onRemove, id]
  );

  return (
    <ListItem
      style={{ marginTop: "1%", alignItems: "flex-start", padding: "0%" }}
    >
      <ListItemText
        primary={"Si el valor NO está en la lista →"}
        secondary={
          <Grid container alignItems="center" spacing={8}>
            <Grid item xs={4}>
              <TextField
                placeholder="A,B,C"
                value={entrada || ""}
                onChange={handleEntradaChange}
                label="Lista separada por coma"
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={6}>
              {suggestions.length > 0 ? (
                <LabeledAutocomplete
                  label="Elementos"
                  isDisabled={false}
                  noOptionsMessage={() => "No se encontraron elementos"}
                  placeholder="Seleccione un elemento"
                  suggestions={suggestions}
                  value={salida}
                  onChange={handleSalidaChange}
                />
              ) : (
                <TextField
                  placeholder="Values..."
                  value={salida || ""}
                  onChange={e => setSalida(e.target.value)}
                  label="Salida"
                  style={{ width: "100%" }}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              <IconButton aria-label="Borrar" onClick={handleRemove}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        }
      />
    </ListItem>
  );
});
